import { Menu } from "@headlessui/react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

const languages = [
  { id: 1, langCode: "en", language: "English", flag: "/images/uk.png" },
  { id: 2, langCode: "de", language: "German", flag: "/images/germany.png" },
  { id: 3, langCode: "fr", language: "French", flag: "/images/france.png" },
  { id: 4, langCode: "es", language: "Spanish", flag: "/images/spain.png" },
  { id: 5, langCode: "nl", language: "Dutch", flag: "/images/netherlands.png" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  let language = languages.find((lang) => lang.langCode === i18n.language);
  if (!language) {
    language = languages[0];
  }

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="bg-gray-200 rounded-md px-[15px] py-[6px] flex items-center gap-[10px]">
        Language
        {language && <img src={language.flag} className="w-[20px]" alt="" />}
      </Menu.Button>
      <Menu.Items className="absolute w-[200px] bg-white bottom-[50px] right-0 shadow-lg rounded-md overflow-hidden">
        {languages.map((language) => (
          <Menu.Item key={language.id}>
            {({ active }) => (
              <button
                className={classNames(
                  "block w-full text-left px-[10px] py-[6px] border-b last:border-none",
                  "flex items-center justify-between",
                  {
                    "bg-[#F8F8F8]": active,
                  }
                )}
                onClick={() => i18n.changeLanguage(language.langCode)}
              >
                {language.language}
                <img src={language.flag} className="w-[24px]" alt="" />
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
}
